import { render } from "./reportiframe.vue?vue&type=template&id=f670c19c"
import script from "./reportiframe.vue?vue&type=script&lang=js"
export * from "./reportiframe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__